import React from "react";

export default function TextInput({
  label,
  name,
  type = "text",
  placeholder,
  value,
  onChange,
  className = "",
  labelClass = "",
  inputClass = "",
  disabled = false,
  required = false,
  error = "",
  min,
  step,
}) {
  return (
    <div className={className}>
      {label && (
        <label htmlFor={name} className={`block text-sm font-medium text-gray-700 mb-1 ${labelClass}`}>
          {label}{required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        min={min}
        step={step}
        className={`w-full px-3.5 py-2.5 border bg-white text-sm text-gray-800 placeholder-gray-400 transition-colors ${
          error ? "border-red-500" : "border-gray-300"
        } rounded-lg focus:outline-none focus:border-[#EE3B31] focus:ring-2 focus:ring-[#EE3B31]/20 ${inputClass}`}
      />
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
}
